import React, { createContext, useContext, useState, useEffect } from 'react';
import { getApiUrl } from '../config/api';
import axios from 'axios';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [widgetSettings, setWidgetSettings] = useState({
    layout: 'grid',
    showWidgetControls: true
  });
  const [isLoading, setIsLoading] = useState(false);

  const loadSettings = async () => {
    // Only load settings if user is authenticated
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }
    
    try {
      setIsLoading(true);
      const response = await axios.get(getApiUrl('/api/settings'));
      
      if (response.data && response.data.dashboard) {
        setWidgetSettings(response.data.dashboard);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const saveSettings = async (newSettings) => {
    // Only save settings if user is authenticated
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }
    
    try {
      setIsLoading(true);
      await axios.post(getApiUrl('/api/settings'), {
        dashboard: newSettings
      });
      setWidgetSettings(newSettings);
      return true;
    } catch (error) {
      console.error('Error saving settings:', error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const updateWidgetSettings = (updates) => {
    const newSettings = { ...widgetSettings, ...updates };
    setWidgetSettings(newSettings);
    return newSettings;
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const value = {
    widgetSettings,
    setWidgetSettings,
    updateWidgetSettings,
    saveSettings,
    loadSettings,
    isLoading
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
